import { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

const isTravelersTripRoute = (route: RouteLocationNormalized) => route.path.includes('/travelers/trip/')

export const NavigationGuard = {
  appendItineraryIdToBookingRoutes: (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
  ): RouteLocationRaw | undefined => {
    if (isTravelersTripRoute(to) && isTravelersTripRoute(from)) {
      const hasNewQueryParams = Object.keys(from.query).some(key => !to.query[key])

      if (hasNewQueryParams) {
        return {
          ...to,
          query: {
            ...from.query,
            ...to.query,
          },
        }
      }
    }
  },
  appendReferrerToUrl: (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
  ): RouteLocationRaw | undefined => {
    const hasSourceQueryParams = Object.keys(from.query).length > 0

    if (hasSourceQueryParams) {
      const mergedQuery = { ...from.query, ...to.query }
      const hasDifferentQueryParams = JSON.stringify(to.query) !== JSON.stringify(mergedQuery)

      if (hasDifferentQueryParams) {
        return {
          ...to,
          query: mergedQuery,
        }
      }
    }
  },
}
